// Copyright (c) RoochNetwork
// SPDX-License-Identifier: Apache-2.0

export const styleDataAttributeName = 'data-sdk-kit'

export const styleDataAttributeSelector = `[${styleDataAttributeName}]`

export const styleDataAttribute = { [styleDataAttributeName]: '' }
